import React from 'react'
import classnames from 'classnames'
import {noop} from 'lodash'

import './Overlay.scss'

interface OverlayProps {
  onPlay: () => void,
  isOverlayVisible: boolean,
  onPauseAnimationEnd?: () => void
}

const Overlay: React.FC<OverlayProps> = ({onPlay, isOverlayVisible, onPauseAnimationEnd = noop}) => (
  <>
    <div styleName="overlay" onClick={onPlay}>
      <div
        styleName={classnames('button', {'is-visible': isOverlayVisible})}
        onAnimationEnd={onPauseAnimationEnd}
      />
    </div>
    <div id="overlay-portal"/>
  </>
)

export default Overlay